export default {
  // BASE_URL: "http://sneho.athmin.com:8080/",
  BASE_URL: "https://stacknodeapi.difotsolutions.com/",
  WEB_URL: "https://app.niyuri.com/",
  // BASE_URL: "https://stacknodeapi.difotsolutions.com/",
  // WEB_URL: "https://stacknodeapi.difotsolutions.com/",
  EMAIL_CLIENT_ID: "c87b8194-0aba-4ade-996d-1f300caf3179",
  BCC_ID: "niyuri-cr_vlp.app@veritaslogistics.com",
  BROKER_URL: "wss://stacknodeapi.difotsolutions.com/emitter/",
  SERVER_NAME: "emailsetting",
  FORGOT_PASSWORD: "api/user/forgotpassword",
  SESSIONS_API_URL: "api/user/sessions",
  TOKEN_HEADER_STRING: "x-auth-token",
  ENTITY_ID: localStorage.getItem("entity_id"),
  USER_QUERY: "/user/query",
  CREATE_USER_QUERY: "/user",
  ENQUIRY_LIST: "/query",
  USER_IMAGE: "/userimage/query",
  USER_TITLE_QUERY: "/titles",
  API: "api/",
  QUERY: "/query",
  API_ENTITY: "api/entity/",
  GOOGLE_MAP_KEY: "AIzaSyCCCpwVmFp_9nMxyWEjIiioNyCo5AdL1ok",
  CHANGEPASSWORD: "/changepassword",
  POD: "/pod",
  REFRESH_TOKEN: "user/refreshtoken",
  NOTIFICATIONHISTORYQUERY: "/notification/history/query",
  NOTIFICATIONHISTORY: "/notification/history",
  FCMTOKEN: "/fcmtoken",
  GENRATE_OTP: "api/user/generateotp",
  LOGOUT: "/logout",
  USER_INFO: localStorage.getItem("user_info")
    ? JSON.parse(localStorage.getItem("user_info"))
    : null,
  USER_ID: localStorage.getItem("user_info")
    ? JSON.parse(localStorage.getItem("user_info")).user_id
    : null,
  GET_USER_ENTITIES: "/userentity/query",
  CLIENT_ID: localStorage.getItem("client_id"),
  SWITCH_TO_NEW_ENTITY: "/switch",
  RESEND_VERIFICATION_MAIL: "/resendverificationemail/user/",
  ACCEPTED: "ACCEPTED",
  ACTIVATED: "ACTIVATED",
  DEACTIVATED: "DEACTIVATED",
  IndiaCode: "in",
  plus: "+",
  COMPLETED: "COMPLETED",
  ROLE: localStorage.getItem("user_info")
    ? JSON.parse(localStorage.getItem("user_info")).role
    : null,
  USER_ADDED_MESSAGE: "User Added successfully.",
  USER_EDIT_MESSAGE: "User Edit successfully.",
  ASC: "ASC",
  DESC: "DESC",
  CUSTOMER_EDIT_MESSAGE: "Customer Edit successfully.",
  API_KEY: "AIzaSyBHjfu5_sM5FyDkVpgqIJ1DJsot3EAIzcg",
  AUTH_DOMAIN: "hopfirst-65914.firebaseapp.com",
  DATABASE_URL: "https://hopfirst-65914.firebaseio.com",
  PROJECT_ID: "hopfirst-65914",
  STORAGE_BUCKET: "hopfirst-65914.appspot.com",
  MESSAGING_SENDER_ID: "189210679564",
  APP_ID: "1:189210679564:web:a74c91b1370c1a55981129",
  MEASURMENT_ID: "G-QN9GJ1V0P2",
  MAX_PERCENTAGE: 100,
  GOOGLE_URL:
    "https://accounts.google.com/o/oauth2/v2/auth?scope=openid%20profile%20email&access_type=offline&include_granted_scopes=true&response_type=code&state=%7Bclient_id%3D",
  GOOGLE_CLIENT_ID: "840712572484-efdasdxds.apps.googleusercontent.com",
  GITHUB_URL:
    "https://github.com/login/oauth/authorize?response_type=code&client_id=",
  GIT_CLIENT_ID: "Iv1.7a166292a2b12537",
  GITHUB_TOKEN_ID: "6e75c7c4139fdba6acc1f2816dd168a6888cdad8",
  GITHUB_STATE_CLIENT_ID: "40676fb05ee1ebeb7868",
  GOOGLE_TOKEN: "f9f49e40-a52e-4f64-9caa-7994c903d03f",
  FACEBOOK_CLIENT_ID: "563195561042500",
  FACEBOOK_TOKEN_ID: "12345678",
  FBURL: "https://www.facebook.com/v8.0/dialog/oauth?",
  MICROSOFTURL:
    "https://login.microsoftonline.com/common/oauth2/v2.0/authorize?response_type=code&client_id=",
  MICROSOFT_CLIENT_ID: "4daf0e13-1dfb-4151-ac58-b99683427c98",
  MS_CLIENT_ID: "1234",
  MS_TOKEN_ID: "123456",
  LINKEDINURL:
    "https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=",
  LINKEDIN_CLIENT_ID: "86vys6ehblhei4",
  LINKEDIN_STATE_CLIENT_ID: "86vys6ehblhei4",
  LINKEDIN_TOKEN_ID: "KsxuXM7GFXVBw9qn",
  APPlE_URL:
    "https://appleid.apple.com/auth/authorize?response_type=code&client_id=",
  APPlE_CLINT_ID: "com.athmin.testauthservice",
  APPLE_ToKEN_ID: "2efda249-fa07-4ee1-b63f-227b82ff24d4",
  ENTITY_TYPE: "SIGNUP_TEST",
  REDIRECT_URL: "http://localhost:4200/login",
  GOOGLE_STR: "google",
  FACEBOOK_STR: "facebook",
  GIT_STR: "github",
  LINKEDIN_STR: "linkedin",
  MSOFT_STR: "microsoft",
  APPLE_STR: "apple",
  RESEND_MOBILE: "RESEND_MOBILE",
  VERIFY_MOBILE: "VERIFY_MOBILE",
  CHANGEMOBILE: "changemobile",
  FILE_UPLOAD: "/file/upload",
  ROLES: [
    {
      name: "User Admin",
      id: "USER_ADMIN",
      value: "CONTROL_TOWER",
    },
    {
      name: "Senior Management",
      id: "SENIOR_MANAGEMENT",
      value: "CONTROL_TOWER",
    },
    {
      name: "Manager",
      id: "MANAGER",
      value: "CONTROL_TOWER",
    },
  ],
  CONVERSATION: "conversation/query",
  CREATE_CONVERSATION: "conversation",
  CREATE_CLIENT: "client",
  CLIENT: "client/query",
  CHANNEL: "crm/channel",
  CONVERSATION_STATUS: "conversationstatus/query",
  TASKTYPE: "conversationtasktype/query",
  PROJECT: "project/query",
  CREATE_PROJECT: "project",
  PROJECT_ADDED_MESSAGE: "Project Added Successfully.",
  EMPLOYEE_ADDED_MESSAGE: "Employee Added Successfully.",
  PROJECT_UPDATED_MESSAGE: "Project Updated successfully.",
  EMPLOYEE_UPDATED_MESSAGE: "Employee Updated successfully.",
  PROJECT_DELETED_MESSAGE: "Project Deleted successfully.",
  EMAIL_CONNECTION_DELETED_MESSAGE: "Email Connection Deleted successfully.",
  EMPLOYEE_DELETED_MESSAGE: "Employee Deleted successfully.",
  CLIENT_DELETED_MESSAGE: "Client Deleted successfully.",
  PROFILE_UPDATED_MESSAGE: "Profile Updated successfully.",
  PROFILE_PICTURE_CHANGE_MESSAGE: "Profile Picture Updated successfully.",
  PROFILE_PICTURE_REMOVE_MESSAGE: "Profile Picture Removed successfully.",
  PASSWORD_UPDATED_MESSAGE: "Password Updated successfully.",
  ACTIVITYTYPEKEY: "activity_type",
  ADDACTIVITYTYPE: "ADD",
  UPDATEACTIVITYTYPE: "UPDATE",
  DELETEACTIVITYTYPE: "DELETE",
  BUCKET: "bucket/query",
  CONVERSATION_STATUS: "conversationstatus/query",
  CONVERSATION_TASK_TYPE: "conversationtasktype/query",
  EMPLOYEE: "client/employee/query",
  CREATE_TASK: "item",
  TASK_ADDED_MESSAGE: "Task Added Successfully.",
  TASK: "item/query",
  TASK_DELETED_MESSAGE: "Task Deleted successfully.",
  CONVERSATION_ACTIVITY: "conversationactivity/query",
  REMOVE_MEDIA: "removemedia",
  CREATE_CONVERSATION_ACTIVITY: "conversation/",
  ACTIVITY_TYPE: "activity_type",
  OBJECT_TYPE: "object_type",
  OBJECT_TYPE_DETAILS: "object_type_details",
  OBJECT_TYPE_ID: "object_type_id",
  FILTER: "filter",
  FILTER_QUERY: "filter/query",
  TASK_ACTIVITY: "item/activity/query",
  EMAIL_QUERY: "email/query",
  EMAIL: "email/",
  CONNECTED_EMAIL_QUERY: "connection/query",
  CONNECT_EMAIL: "connect",
  CLIENT_ACTIVITY: "clientactivity/query",
  EMAIL_CONNECTION: "email/connection/",
  LOCATION_API: "https://ltdash.veritaslogistics.com/niyuriconfig/",
  SECONDARY_DASHBOARD_API: "item/dashboard",
};
